import styled from "styled-components";

export const Layout = styled.div`
  width: 250px;

  .option-description {
    // hides the description when the menu is not opened
    display: none;
  }
`;

export const Option = styled.div``;

export const OptionTitle = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;
export const OptionText = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const OptionDescription = styled.div`
  margin-left: 18px;
  color: var(--theme-neutral-400);
`;
